import { Pagination } from '@/providers/turn/types';

export const PAGINATION_OPTIONS: Pagination = { page: 1, perPage: 1000 };

export const path = (path: 'county') => path;
